export default {
	editEventDate: "Modifier la date d’entrée ou de sortie",
	becomeMedium: "Devenir médium",
	leaveMedium: "Quitter la corrente",
	becomeMediumTitle: "Devenir médium",
	leaveMediumTitle: "Quitter la corrente",
	becomeMediumConfirm: "Confirmer l'entrée dans la corrente",
	leaveMediumConfirm: "Confirmer la sortie de la corrente",
	entryEvent: "Entrée dans la corrente",
	exitEvent: "Sortie de la corrente",
	date: "Date",
	reason: "Motif",
	notes: "Notes",
	entryDate: "Date d'entrée dans la corrente",
	entryNotes: "Observations de l'entrée",
	personSource: {
		existing: "Déjà enregistrée",
		new: "Enregistrer",
	},
	reasons: {
		voluntary: "Départ volontaire",
		disciplinary: "Départ disciplinaire",
		transfer: "Transféré vers un autre temple",
		other: "Autre",
	},
	leaveMediumWarning: "Cette action désactivera également toutes les étapes de parcours actives de cette personne.",
	success: {
		entry: "La personne est maintenant médium dans la corrente",
		exit: "Personne retirée de la corrente",
	},
	timeline: {
		title: "Historique",
		empty: "Aucun enregistrement trouvé",
		by: "par",
	},
};
